module.exports = __webpack_public_path__ + "static/media/16_plantilla_rec_combo_simple_cf_gaseosas_pet_2_25_sp.1941241a.png";